import type { FunctionComponent } from "preact";

import "./not-found.css";

const NotFound: FunctionComponent = () => {
	return (
		<div class="not-found">
			<h2 class="not-found--title">404 Not Found</h2>
		</div>
	);
};
export default NotFound;
